import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectValues',
  standalone: true,
})
export class ObjectValuesPipe implements PipeTransform {
  transform(value: Record<string, string>): string[] {
    return value ? Object.values(value) : [];
  }
}
